var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2034_4396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2034_4396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7999 22.6L16.7749 19.5751C16.3582 19.8417 15.9166 20.0709 15.4499 20.2626C14.9832 20.4542 14.4999 20.6084 13.9999 20.725V18.675C14.2332 18.5917 14.4624 18.5084 14.6874 18.425C14.9124 18.3417 15.1249 18.2417 15.3249 18.1251L11.9999 14.8V20L6.9999 15H2.9999V9.00005H6.1999L1.3999 4.20005L2.7999 2.80005L21.1999 21.2001L19.7999 22.6ZM19.5999 16.8L18.1499 15.35C18.4332 14.8334 18.6457 14.2917 18.7874 13.725C18.9291 13.1584 18.9999 12.5751 18.9999 11.975C18.9999 10.4084 18.5416 9.00838 17.6249 7.77505C16.7082 6.54172 15.4999 5.70838 13.9999 5.27505V3.22505C16.0666 3.69172 17.7499 4.73755 19.0499 6.36255C20.3499 7.98755 20.9999 9.85838 20.9999 11.975C20.9999 12.8584 20.8791 13.7084 20.6374 14.5251C20.3957 15.3417 20.0499 16.1 19.5999 16.8ZM16.2499 13.45L13.9999 11.2V7.95005C14.7832 8.31672 15.3957 8.86672 15.8374 9.60005C16.2791 10.3334 16.4999 11.1334 16.4999 12C16.4999 12.25 16.4791 12.4959 16.4374 12.7375C16.3957 12.9792 16.3332 13.2167 16.2499 13.45ZM11.9999 9.20005L9.3999 6.60005L11.9999 4.00005V9.20005Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.9f9505004ed02a8195dc3b1cdd0e143e.svg";
export { ForwardRef as ReactComponent };